// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Groups_loadingOverlay__3kXDn"};